import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';
import ReactMarkdown from 'react-markdown';

import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { PlayerBioContainer, PlayerBioName, PlayerBioText, PlayerSectionHeader } from '../styles';
import { Player, PlayerBioItem } from '../types';

type PlayerBioProps = {
    bio: PlayerBioItem['fields'];
    player: Player;
};
export const PlayerBio: FC<PlayerBioProps> = ({ bio, player }) => {
    const biography = bio && bio?.biography;

    return bio?.biography !== undefined ? (
        <>
            <PlayerSectionHeader aria-level={2}>
                <FormattedMessage defaultMessage="Bio" description="A header describing a player's biography" />
            </PlayerSectionHeader>

            <PlayerBioContainer>
                <div>
                    <PlayerBioName>{`${parseValueFromLocalizedAttribute(
                        player?.firstName
                    )} ${parseValueFromLocalizedAttribute(player?.lastName)}`}</PlayerBioName>
                    <PlayerBioText>
                        <ReactMarkdown>{biography}</ReactMarkdown>
                    </PlayerBioText>
                </div>
            </PlayerBioContainer>
        </>
    ) : null;
};
